import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { ModelUploadedPayload } from './interfaces/model-uploaded-payload.interface';
import { isNonNullObject } from 'utilities';

export const ModelUploadMessage: MessageHandler<ModelUploadedPayload> = {
  send(payload: ModelUploadedPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.ModelUploaded, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is ModelUploadedPayload {
    return (
      isNonNullObject(payload) &&
      'modelId' in payload &&
      typeof payload.modelId === 'string' &&
      'projectId' in payload &&
      typeof payload.projectId === 'string' &&
      'name' in payload &&
      typeof payload.name === 'string'
    );
  },
};
